<template>
    <div>
        <div class="app-title">
            <em-view-title :crudState="$_emCommonEditMixin_pathType"></em-view-title>
        </div>
        <section class="app-content" v-menu-permission="'edit'">
            <div class="card">
                <div class="card-body">
                    <em-entity-edit-form ref="emEntityEditForm" :entity="modelName"
                                         :$_em-custom-vuex-mixin_entity="entityState"></em-entity-edit-form>
                    <b-button @click="switchEntityName" v-if="inspectType!==''">选取关联任务</b-button>
                </div>
            </div>
        </section>
        <em-modal-entity-selector ref="entitySelector" disable-store
                                  @entityModalSelectSelected="updateValue"></em-modal-entity-selector>
    </div>
</template>

<script>
// Author Liang Gang Qiang
// Date 2021-10-14 16:35:28

import emCommonEditMixin from "@/mixin/em/common/edit";
import emCustomVuexMixin from "@/mixin/em/customVuex";
import EmModalEntitySelector from "@/components/em/EmModal/EntitySelector";
import {_inspectType2EntityName} from "@/views/mintalMes/quality/js/inspectUtils";

export default {
    name: "mintalMesQualityProductionProjectEditView",
    components: {EmModalEntitySelector},
    mixins: [emCommonEditMixin, emCustomVuexMixin],
    computed: {
        entity() {
            return this.modelName;
        },
        modelName() {
            return this.$_emRouterHelperMixin_entityName
        },
        entityState() {
            return this.$route.query.hasOwnProperty('entityState') ? this.$route.query.entityState : 'entity';
        },
        // returnPath() {
        //     return "/mintalMes/quality/mintalMesQualityProductionProjectList/" +
        //         this.entityState.substring(0, this.entityState.lastIndexOf('Entity'));
        // },
        inspectType() {
            if (this.$_emCustomVuexMixin_entityStore) {
                return this.$_emCustomVuexMixin_entityStore.inspectType;
            }
            return "";
        }
    },
    data() {
        return {
            entityName: ''
        }
    },
    methods: {
        updateValue(row) {
            console.log(row)
            this.$_emCustomVuexMixin_setEntityAttribute('inspectObject', row.id);
        },
        switchEntityName() {
            let customVuexName = undefined;
            let name = _inspectType2EntityName(this.inspectType);
            if (name) {
                this.entityName = name;
                if (this.inspectType === '3') {
                    customVuexName = 'pelletizing';
                }
                this.$refs.entitySelector.setCustomVuexConfig(this.entityName, customVuexName, 30,
                    customVuexName ? 'findByFilter/' + customVuexName : undefined);
                this.$refs.entitySelector.onlyShowModal();
            }
        }
    }
};
</script>